// extracted by mini-css-extract-plugin
module.exports = {"component":"Read_component__2DP8V","small":"Read_small__37DWT","block":"Read_block__2nrIs"};